import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
} from "@chakra-ui/react";
import { DateTime } from "luxon";
import { useState } from "react";
import { BsPencil } from "react-icons/bs";
import { EditProgrammeModal } from "./EditProgrammeModal";
import { MdOutlineDeleteForever } from "react-icons/md";
import { DeleteProgrammeModal } from "./DeleteProgrammeModal";

export const ProgrammeList = ({ isOpen, onClose, data, id, func }: any) => {
  const [selectedProgramme, setSelectedProgramme] = useState<any>(null);
  const {
    isOpen: isModalOpen,
    onOpen,
    onClose: onModalClose,
  } = useDisclosure();
  const [modal, setModal] = useState("");
  const handleEditClick = (programme: any) => {
    setSelectedProgramme(programme);
    setModal("editmodal");
    onOpen();
  };

  return (
    <>
      <Modal size={"6xl"} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Attendance</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {data.length > 0 ? (
              <div className="col-sm-12 card">
                <table className="table table-striped mt-4">
                  <thead>
                    <tr>
                      <th style={{ width: "150px" }}>Date</th>
                      <th style={{ width: "150px" }}>Time</th>
                      <th style={{ width: "150px" }}>Status</th>
                      <th style={{ width: "150px" }}>Modified Status</th>
                      <th style={{ width: "150px" }}>No of Attendee</th>
                      <th style={{ width: "150px" }}>Edit</th>
                      <th style={{ width: "150px" }}>Delete</th>
                      {/* <th style={{ width: "150px" }}>Program Id</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((el: any) => (
                      <tr key={el.id}>
                        <td
                          style={{
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {DateTime.fromFormat(el.date, "MM/dd/yyyy").toFormat(
                            "dd-LLL-yy"
                          )}
                        </td>
                        <td
                          style={{
                            minWidth: "150px",
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {el.time}
                        </td>
                        <td
                          style={{
                            minWidth: "250px",
                            maxWidth: "250px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {el.status}
                        </td>
                        <td
                          style={{
                            minWidth: "250px",
                            maxWidth: "250px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {el.modified_status ? el.modified_status : ""}
                        </td>
                        <td
                          style={{
                            maxWidth: "150px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {el.no_of_attendee}
                        </td>
                        <td>
                          <div className="edit-icon">
                            <BsPencil onClick={() => handleEditClick(el)} />
                          </div>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <span title="Delete">
                              <MdOutlineDeleteForever
                                className="deleteButton pointer"
                                onClick={() => {
                                  setSelectedProgramme(el);
                                  setModal("deletemodal");
                                  onOpen();
                                }}
                              />
                            </span>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              "No Program available."
            )}
          </ModalBody>

          <ModalFooter>
            <Button bgColor="red" color={"white"} mr={3} onClick={onClose}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {selectedProgramme && modal === "editmodal" &&(
        <EditProgrammeModal
          data={selectedProgramme}
          isOpen={isModalOpen}
          onClose={() => {
            onModalClose();
            setSelectedProgramme(null);
          }}
          clear={() => setSelectedProgramme(null)}
          id={id}
          uuid={selectedProgramme.id}
          func={func}
        />
      )}

      {selectedProgramme && modal === "deletemodal" && (
        <DeleteProgrammeModal
          isOpen={isOpen}
          onClose={onClose}
          func={func}
          clear={() => setSelectedProgramme(null)}
          id={selectedProgramme.id}
          expertid={id}
        />
      )}
    </>
  );
};
